const initialState = {
  loading: false,
  errorData: {},
  errorMessage: '',
  refreshData: false,
}

export const commonReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LOADING_STARTED':
      return {
        ...state,
        loading: true,
      }
    case 'LOADING_COMPLETED':
      return {
        ...state,
        loading: false,
      }
    case 'LOADING_FAILURE':
      return {
        ...state,
        loading: false,
      }
    case 'ERROR':
      return {
        ...state,
        errorMessage: action.payload?.errorMessage,
      }
    case 'REFRESH_DATA':
      return {
        ...state,
        refreshData: !state.refreshData,
      }
    case 'CLEAR_COMMON':
      return {
        ...state,
        loading: false,
        errorData: {},
        errorInfo: '',
      }
    default:
      return state
  }
}
